/**
 * Possible positions for the title columns.
 *
 * How to read: position horizontal position_vertical position
 * Means: LEFT_CENTER --> left aligned horizontal and centered vertial
 */
export enum TitlePositions {
  CENTER_CENTER = 'CENTER_CENTER',
  LEFT_CENTER = 'LEFT_CENTER',
  RIGHT_CENTER = 'RIGHT_CENTER'
}
